import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment-timezone';
import _ from 'lodash';
import { OrderActions, LocationActions, PrintActions } from '../../actions';
import Loader from '../../components/Loader';
import TitleBar from '../../components/TitleBar';
import SubnavBar from '../../components/SubnavBar';
import OrderForm from '../../components/Orders/Edit';
import { CODES, ORDER_STATUS, SERVICE_LEVELS } from '../../constants';


export class EditOrder extends Component {
  componentWillMount() {
    const { locations } = this.props;
    if (!locations) {
      this.props.dispatch(LocationActions.getLocations());
    }
  }

  gotoOrders = () => {
    browserHistory.push('/orders');
  }

  mergeDateAndTime = (date, time) => {
    const newDate = moment(date);
    const newTime = moment(time);
    newDate.hour(newTime.hour());
    newDate.minute(newTime.minute());
    return newDate;
  }

  getLocationId = (locationName) => {
    const { locations } = this.props;
    const item = _.find(locations.list, { name: locationName });
    return item.id;
  }

  getLocation = (locationId) => {
    const { locations } = this.props;
    return _.find(locations.list, item => item.id === locationId);
  }

  saveOrder = (values) => {
    const order = {
      reference: values.reference,
      weight: values.weight,
      pieces: values.pieces,
      fromLocationId: this.getLocationId(values.fromLocation),
      toLocationId: this.getLocationId(values.toLocation),
      codeId: values.codeId || CODES.L1.id,
      statusId: values.statusId || ORDER_STATUS.PENDING.id,
      serviceLevelId: values.serviceLevelId || SERVICE_LEVELS.NEXT_AVAILABLE.id,
      consigneeId: values.consigneeId || null,
    };
    if (values.pickupDate) {
      order.pickupDate = this.mergeDateAndTime(values.pickupDate, values.pickupTime).toString();
    }
    if (values.deliverDate) {
      order.deliverDate = this.mergeDateAndTime(values.deliveryDate, values.deliveryTime).toString();
    }
    return this.props.dispatch(OrderActions.saveOrder(order)).then((response) => {
      const fromLocation = this.getLocation(response.order.fromLocationId);
      const toLocation = this.getLocation(response.order.toLocationId);
      this.props.dispatch(PrintActions.saveDetails(fromLocation, toLocation, response.order));
      browserHistory.push(`/label/${response.order.trackingNumber}`);
    });
  }

  render() {
    const { locations } = this.props;
    let content = <Loader />;

    if (locations && !locations.fetching) {
      content = <OrderForm onSubmit={this.saveOrder} locations={locations} />;
    }

    return (
      <div>
        <div className="row">
          <div className="col s12">
            <SubnavBar back={this.gotoOrders} />
            <TitleBar title="Order" />
            <div className="row">
              <div className="col s12">
                {content}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapPropsToState = (state) => {
  const { auth, locations } = state;
  return {
    auth,
    locations
  }
}

export default connect(mapPropsToState)(EditOrder);


// WEBPACK FOOTER //
// ./src/containers/Orders/Edit.js